import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("会話の教室ID修正結果")
const _hoisted_2 = { class: "space-y-6" }
const _hoisted_3 = { class: "text-lg font-bold text-gray-800 mb-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-md p-3"
}
const _hoisted_6 = { class: "text-sm text-red-700" }
const _hoisted_7 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_8 = { class: "bg-gray-50 rounded-md p-3 text-center" }
const _hoisted_9 = { class: "text-2xl font-bold text-gray-600" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "確認した生徒数", -1)
const _hoisted_11 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_12 = { class: "grid grid-cols-3 gap-4" }
const _hoisted_13 = { class: "bg-gray-50 rounded-md p-3 text-center" }
const _hoisted_14 = { class: "text-2xl font-bold text-gray-600" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "確認した生徒数", -1)
const _hoisted_16 = { class: "bg-green-50 rounded-md p-3 text-center" }
const _hoisted_17 = { class: "text-2xl font-bold text-green-600" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "修正した生徒数", -1)
const _hoisted_19 = { class: "bg-blue-50 rounded-md p-3 text-center" }
const _hoisted_20 = { class: "text-2xl font-bold text-blue-600" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "text-xs text-gray-500" }, "修正した会話数", -1)
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "text-sm font-medium text-gray-700 mb-2" }
const _hoisted_24 = { class: "bg-red-50 border border-red-200 rounded-md overflow-hidden" }
const _hoisted_25 = { class: "w-full text-sm" }
const _hoisted_26 = /*#__PURE__*/_createVNode("thead", { class: "bg-red-100" }, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left text-gray-700" }, "生徒ID"),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left text-gray-700" }, "教室ID"),
    /*#__PURE__*/_createVNode("th", { class: "px-3 py-2 text-left text-gray-700" }, " 失敗した会話ID ")
  ])
], -1)
const _hoisted_27 = { class: "px-3 py-2 text-gray-600 font-mono text-xs" }
const _hoisted_28 = { class: "px-3 py-2 text-gray-600 font-mono text-xs" }
const _hoisted_29 = { class: "px-3 py-2 text-gray-600 font-mono text-xs break-all" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 閉じる ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, {
    size: "wide",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
  }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
          return (_openBlock(), _createBlock("div", {
            key: result.schoolDocId,
            class: "border border-gray-200 rounded-lg p-4"
          }, [
            _createVNode("h3", _hoisted_3, _toDisplayString(_ctx.schoolNameMap[result.schoolDocId] || result.schoolDocId), 1),
            _createVNode("div", _hoisted_4, [
              _createVNode("span", {
                class: ["inline-block px-3 py-1 rounded-full text-sm font-medium", _ctx.getStatusBadgeClass(result.status)]
              }, _toDisplayString(_ctx.getStatusLabel(result)), 3)
            ]),
            (result.status === 'failure')
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode("p", _hoisted_6, _toDisplayString(result.errorMessage), 1)
                ]))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  (result.fixedStudentCount === 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        _createVNode("div", _hoisted_8, [
                          _createVNode("div", _hoisted_9, _toDisplayString(result.checkedStudentCount), 1),
                          _hoisted_10
                        ])
                      ]))
                    : (_openBlock(), _createBlock("div", _hoisted_11, [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("div", _hoisted_13, [
                            _createVNode("div", _hoisted_14, _toDisplayString(result.checkedStudentCount), 1),
                            _hoisted_15
                          ]),
                          _createVNode("div", _hoisted_16, [
                            _createVNode("div", _hoisted_17, _toDisplayString(result.fixedStudentCount), 1),
                            _hoisted_18
                          ]),
                          _createVNode("div", _hoisted_19, [
                            _createVNode("div", _hoisted_20, _toDisplayString(result.fixedConversationCount), 1),
                            _hoisted_21
                          ])
                        ])
                      ])),
                  (result.failures && result.failures.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_22, [
                        _createVNode("h4", _hoisted_23, " 失敗した生徒（" + _toDisplayString(result.failures.length) + "件） ", 1),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("table", _hoisted_25, [
                            _hoisted_26,
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(result.failures, (failure, idx) => {
                                return (_openBlock(), _createBlock("tr", {
                                  key: idx,
                                  class: "border-t border-red-200"
                                }, [
                                  _createVNode("td", _hoisted_27, _toDisplayString(failure.studentDocId), 1),
                                  _createVNode("td", _hoisted_28, _toDisplayString(failure.classroomId), 1),
                                  _createVNode("td", _hoisted_29, _toDisplayString(failure.failedConversationIds.join(", ")), 1)
                                ]))
                              }), 128))
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
          ]))
        }), 128))
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_m_button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, {
        default: _withCtx(() => [
          _hoisted_30
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}